<div class="card">
  <div class="card-header bg-warning text-white">
    <h5><i class="fas fa-calendar"></i> Configuración de Fechas de Vencimiento</h5>
  </div>
  <div class="card-body">
    <div class="alert alert-info">
      <i class="fa fa-info-circle"></i>
      <strong>Instrucciones:</strong> Configure qué día del mes vence cada terminación de CUIT (0-9).
      Cada terminación debe estar asignada a exactamente un día. El sistema ajustará automáticamente si la fecha cae en sábado o domingo (pasa al lunes siguiente).
    </div>

    <!-- Loading spinner -->
    <div *ngIf="loading" class="text-center my-4">
      <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
      <p class="mt-2">Cargando...</p>
    </div>

    <div *ngIf="!loading">
      <!-- Lista de días configurados -->
      <div class="row mb-4">
        <div class="col-md-12">
          <h6><strong>Días de Vencimiento Configurados:</strong></h6>

          <div *ngIf="diasVencimiento.length === 0" class="alert alert-warning">
            No hay días configurados. Agregue al menos un día de vencimiento.
          </div>

          <div *ngFor="let dia of diasVencimiento" class="card mb-3">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-2">
                  <h5 class="mb-0 text-primary">Día {{ dia.dia }}</h5>
                  <small class="text-muted">{{ dia.descripcion }}</small>
                </div>
                <div class="col-md-8">
                  <div class="terminaciones-container">
                    <strong>Terminaciones:</strong>
                    <span *ngIf="dia.terminaciones.length === 0" class="text-muted ml-2">
                      <em>Ninguna asignada</em>
                    </span>
                    <span *ngFor="let term of dia.terminaciones" class="badge badge-primary mr-1">
                      {{ term }}
                      <i class="fa fa-times ml-1" style="cursor: pointer;" (click)="eliminarTerminacion(dia, term)" title="Quitar terminación"></i>
                    </span>

                    <!-- Selector para agregar terminación -->
                    <select class="form-control form-control-sm d-inline-block ml-2" style="width: 180px;"
                            (change)="agregarTerminacion(dia, +$event.target.value); $event.target.value=''">
                      <option value="">+ Agregar terminación</option>
                      <option *ngFor="let t of terminacionesDisponibles" [value]="t">Terminación {{ t }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 text-right">
                  <button type="button" class="btn btn-sm btn-danger" (click)="eliminarDiaVencimiento(dia)">
                    <i class="fa fa-trash"></i> Eliminar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <!-- Agregar nuevo día -->
      <div class="row mb-4">
        <div class="col-md-12">
          <h6><strong>Agregar Nuevo Día de Vencimiento:</strong></h6>
          <div class="form-row">
            <div class="col-md-2">
              <label for="nuevoDia">Día del mes</label>
              <input type="number" class="form-control" id="nuevoDia" [(ngModel)]="nuevoDiaVencimiento" min="1" max="31">
            </div>
            <div class="col-md-6">
              <label for="nuevaDesc">Descripción (opcional)</label>
              <input type="text" class="form-control" id="nuevaDesc" [(ngModel)]="nuevaDescripcion" placeholder="Ej: Vencimiento para terminaciones 0-3">
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <button type="button" class="btn btn-success" (click)="agregarDiaVencimiento()">
                <i class="fa fa-plus"></i> Agregar Día
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr>

      <!-- Resumen -->
      <div class="row mb-4">
        <div class="col-md-12">
          <h6><strong>Resumen:</strong></h6>
          <div class="alert" [class.alert-success]="getTerminacionesDisponibles().length === 0"
                             [class.alert-warning]="getTerminacionesDisponibles().length > 0">
            <strong>Terminaciones sin asignar:</strong>
            <span *ngIf="getTerminacionesDisponibles().length === 0" class="text-success">
              <i class="fa fa-check-circle"></i> Todas las terminaciones están asignadas
            </span>
            <span *ngIf="getTerminacionesDisponibles().length > 0">
              {{ getTerminacionesDisponibles().join(', ') }}
            </span>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-secondary mr-2" (click)="cancelarCambios()">
            <i class="fa fa-times"></i> Cancelar Cambios
          </button>
          <button type="button" class="btn btn-primary" (click)="guardarConfiguracion()"
                  [disabled]="getTerminacionesDisponibles().length > 0 || loading">
            <i class="fa fa-save"></i> Guardar Configuración
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
